import { render } from "./SessionsPage.vue?vue&type=template&id=1c5f487a&scoped=true"
import script from "./SessionsPage.vue?vue&type=script&lang=js"
export * from "./SessionsPage.vue?vue&type=script&lang=js"

import "./SessionsPage.vue?vue&type=style&index=0&id=1c5f487a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5f487a"]])

export default __exports__